<template>
    <div
        class="preview"
        :class="{
            desktop: device === 1,
            tablet: device === 2,
            ios: device === 3,
            android: device === 4,
        }"
    >
        <div class="d-flex flex-column justify-content-center align-items-center">
            <a-button-group class="mb-1">
                <a-button @click="device = 1" :type="device === 1 ? 'primary' : ''">
                    {{ $t("fastWizard.previewDesktop") }}
                </a-button>
                <a-button @click="device = 2" :type="device === 2 ? 'primary' : ''"
                    >{{ $t("fastWizard.previewIpad") }}
                </a-button>
                <a-button @click="device = 3" :type="device === 3 ? 'primary' : ''">IOS</a-button>
                <a-button @click="device = 4" :type="device === 4 ? 'primary' : ''">Android</a-button>
            </a-button-group>
            <div class="marvel-device macbook" v-if="device === 1">
                <div class="top-bar"></div>
                <div class="camera"></div>
                <div class="screen">
                    <img
                        v-if="!!settings.website && uploaded.includes(settings.website)"
                        :src="screenshots().desktop"
                        style="width: 100%; height: 100%"
                        :key="'desktop' + renderCount"
                    />
                </div>
                <div class="bottom-bar"></div>
            </div>
            <div class="marvel-device ipad silver" v-if="device === 2">
                <div class="camera"></div>
                <div class="screen">
                    <img
                        v-if="!!settings.website && uploaded.includes(settings.website)"
                        :src="screenshots().tablet"
                        style="width: 100%; height: 100%"
                        :key="'tablet' + renderCount"
                    />
                </div>
                <div class="home"></div>
            </div>
            <div class="marvel-device iphone-x" v-if="device === 3">
                <div class="notch">
                    <div class="camera"></div>
                    <div class="speaker"></div>
                </div>
                <div class="top-bar"></div>
                <div class="sleep"></div>
                <div class="bottom-bar"></div>
                <div class="volume"></div>
                <div class="overflow">
                    <div class="shadow shadow--tr"></div>
                    <div class="shadow shadow--tl"></div>
                    <div class="shadow shadow--br"></div>
                    <div class="shadow shadow--bl"></div>
                </div>
                <div class="inner-shadow"></div>
                <div class="screen">
                    <img
                        v-if="!!settings.website && uploaded.includes(settings.website)"
                        :src="screenshots().mobile"
                        style="width: 100%; height: 100%"
                        :key="'ios' + '' + renderCount"
                    />
                </div>
            </div>
            <div class="marvel-device note8" v-if="device === 4">
                <div class="inner"></div>
                <div class="overflow">
                    <div class="shadow"></div>
                </div>
                <div class="speaker"></div>
                <div class="sensors"></div>
                <div class="more-sensors"></div>
                <div class="sleep"></div>
                <div class="volume"></div>
                <div class="camera"></div>
                <div class="screen">
                    <img
                        v-if="!!settings.website && uploaded.includes(settings.website)"
                        :src="screenshots().mobile"
                        style="width: 100%; height: 100%"
                        :key="'android' + renderCount"
                    />
                </div>
            </div>
            <LivePreview />
        </div>
    </div>
</template>

<script>
import log2 from "../../utils/log2";
import { mapActions, mapGetters, mapState } from "vuex";
import { sendSocketMessage } from "../../utils/socketStream";
import "../../assets/css/device.min.css";
import _ from "lodash";
import LivePreview from "./LivePreview";

const log = log2("Preview");
export default {
    name: "Preview",
    components: { LivePreview },
    data() {
        return {
            device: 1,
            renderCount: 1,
            uploaded: [],
        };
    },
    computed: {
        ...mapState({
            settings: (state) => state.setting.settings,
            site: (state) => state.site.site,
        }),
    },
    methods: {
        ...mapActions({
            getSettings: "setting/getSettings",
            updateSettings: "setting/updateSettings",
            setSettingValue: "setting/setSettingValue",
        }),
        screenshots() {
            const { website } = this.settings;
            if (website && website.length) {
                const hostname = new URL(website.startsWith("http") ? website : `http://${website}`).hostname;
                const prefix = hostname.trim().toLowerCase();
                const randomId = Math.ceil(Math.random() * 10000);
                return {
                    desktop: `https://static.supsis.live/website-screenshots/${prefix}/desktop.jpg?i=${randomId}`,
                    mobile: `https://static.supsis.live/website-screenshots/${prefix}/mobile.jpg?i=${randomId}`,
                    tablet: `https://static.supsis.live/website-screenshots/${prefix}/tablet.jpg?i=${randomId}`,
                };
            }
            return {
                desktop: undefined,
                mobile: undefined,
                tablet: undefined,
            };
        },
        applySettings(newSettings) {
            log("applySettings", newSettings);
            this.updateSettings(newSettings).then(() => {
                sendSocketMessage("user settings-updated", {
                    siteId: this.site._id,
                });
            });
        },
    },
    mounted() {
        this.timerId = setInterval(async () => {
            const { website } = this.settings;
            const { desktop } = this.screenshots();
            log("check before", { website, desktop });
            if (website && desktop) {
                if (this.uploaded.includes(website)) return;
                log(`checking ${website}`);
                const status = (await fetch(desktop).then((x) => x.text())) || "";
                log(`check result ${website}`, { status });
                if (status.indexOf("Error") === -1) {
                    this.uploaded.push(website);
                    this.renderCount += 1;
                }
            }
        }, 2000);
    },
    beforeDestroy() {
        if (this.timerId) clearInterval(this.timerId);
    },
    watch: {
        settings: {
            handler: function (newSettings) {},
            deep: true,
        },
    },
};
</script>

<style lang="scss"></style>
